import styled from 'styled-components';
import { MarkdownViewer } from '@ardoq/markdown';
import { spacing } from '@ardoq/design-tokens';

const StyledText = styled.div`
  display: block;
  overflow-wrap: anywhere;
  p {
    margin-top: 0;
    margin-bottom: ${spacing.s8};
  }

  p:last-child {
    margin-bottom: 0;
  }

  strong {
    -webkit-font-smoothing: antialiased;
    font-weight: bold;
  }
  @media only screen and (max-width: 850px),
    (min-device-width: 768px) and (max-device-width: 1024px) {
    margin: 0;
    width: 100%;
  }
`;

type SurveyHelpTextProps = {
  text: string;
};

export const SurveyHelpText = ({ text }: SurveyHelpTextProps) => {
  return (
    <StyledText>
      <MarkdownViewer content={text} sanitationLevel="permissive" />
    </StyledText>
  );
};
